import { IRapportMallJson } from '../../RapportMall';
import {
  IRapportMallControl,
  isRapportContentControl,
  isRapportAssociationControl,
  isRapportTextControl,
  isRapportTextBoxControl,
  isRapportEditBoxControl,
  isRapportCheckBoxControl,
  isRapportDataSetControl,
  isRapportSpacingControl,
  isRapportAddressWindowControl,
  isRapportNewPageControl,
  isRapportLineControl,
  isRapportBoxControl,
  isRapportContainerControl,
  isRapportConditionControl,
  mallControlInfo,
} from '../../RapportMallTypes';

export type TreeItem = {
  id: string;
  label: React.ReactNode;
  children?: TreeItem[];
};

export const controlLabel = (ctrl: IRapportMallControl): string => {
  const title = mallControlInfo(ctrl)?.title || `${ctrl.Type}`;
  const limit = (s: string, max: number) =>
    typeof s === 'string' && s.length > max ? `${s.slice(0, max)}....` : s;
  // Attempt to enrich label with a meaningful field depending on type
  if (isRapportTextControl(ctrl) && ctrl.Text)
    return `${title} - ${limit(ctrl.Text, 60)}`;
  if (isRapportTextBoxControl(ctrl) && ctrl.Caption)
    return `${title} - ${ctrl.Caption}`;
  if (isRapportEditBoxControl(ctrl) && ctrl.Name)
    return `${title} - ${ctrl.Name}`;
  if (isRapportCheckBoxControl(ctrl)) {
    const name = ctrl.Name || ctrl.Caption;
    if (name) return `${title} - ${name}`;
  }
  if (isRapportDataSetControl(ctrl) && ctrl.Association)
    return `${title} - ${ctrl.Association}`;
  if (isRapportSpacingControl(ctrl) && ctrl.Spacing != null)
    return `${title} - ${ctrl.Spacing}`;
  if (isRapportAddressWindowControl(ctrl)) return `${title}`;
  if (isRapportNewPageControl(ctrl)) return `${title}`;
  if (isRapportLineControl(ctrl)) return `${title}`;
  if (isRapportBoxControl(ctrl)) return `${title}`;
  if (isRapportContainerControl(ctrl)) return `${title}`;
  if (isRapportConditionControl(ctrl)) return `${title}`;
  return title;
};

export const buildControlItem = (
  ctrl: IRapportMallControl,
  path: number[]
): TreeItem => {
  const id = path.join('-');
  const children: TreeItem[] = [];

  if (isRapportContentControl(ctrl) && Array.isArray(ctrl.Content)) {
    ctrl.Content.forEach((child, idx) => {
      children.push(buildControlItem(child, [...path, idx]));
    });
  }
  if (isRapportAssociationControl(ctrl) && Array.isArray(ctrl.Template)) {
    ctrl.Template.forEach((child, idx) => {
      children.push(buildControlItem(child, [...path, idx]));
    });
  }

  return {
    id,
    label: controlLabel(ctrl),
    children: children.length ? children : undefined,
  };
};

export const buildItems = (mall: IRapportMallJson | null): TreeItem[] => {
  if (!mall) return [];
  const bodyItems: TreeItem[] = (mall.Body || []).map((ctrl, idx) =>
    buildControlItem(ctrl, [idx])
  );
  return [
    {
      id: 'root',
      label: 'Rapportmall',
      children: bodyItems,
    },
  ];
};
